import BaseService from "@/boot/BaseService";
class AuthService extends BaseService {
    constructor() {
        super(null, null, true); // useAuthClient = true para configuración con CSRF
    }
    async register(formData) {
        return await this.post('/register', formData);
    }
    async login(form) {
        await this.get('/sanctum/csrf-cookie');
        return await this.post('/login', form);
    }

    async logout() {
        return await this.post('/logout');
    }


    async azureLogin() {
        return await this.get('/auth/azure');
    }
    async azureCallback(code) {
        return await this.get('/auth/callback', { code });
    }

}

export default new AuthService();
